var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilverBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.375C15.1777 19.375 19.375 15.1777 19.375 10C19.375 4.82233 15.1777 0.625 10 0.625C4.82233 0.625 0.625 4.82233 0.625 10C0.625 15.1777 4.82233 19.375 10 19.375Z",
    fill: "#FAA037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6436 3.3938C18.1439 5.26366 18.8708 7.63723 18.675 10.0266C18.4792 12.4159 17.3755 14.6394 15.5908 16.2401C13.806 17.8407 11.4759 18.6968 9.07946 18.6324C6.68297 18.568 4.40222 17.588 2.70605 15.8938C3.50363 16.8878 4.49552 17.7088 5.6211 18.3066C6.74669 18.9044 7.98233 19.2664 9.25254 19.3705C10.5227 19.4745 11.8008 19.3186 13.0087 18.912C14.2166 18.5055 15.3289 17.857 16.2777 17.006C17.2265 16.1551 17.9918 15.1197 18.5269 13.963C19.062 12.8063 19.3557 11.5527 19.3899 10.2786C19.4241 9.00464 19.1983 7.73703 18.7261 6.55327C18.2539 5.36951 17.5453 4.29446 16.6436 3.3938Z",
    fill: "#F5732D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.875C13.797 16.875 16.875 13.797 16.875 10C16.875 6.20304 13.797 3.125 10 3.125C6.20304 3.125 3.125 6.20304 3.125 10C3.125 13.797 6.20304 16.875 10 16.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_277_291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00391 14.6504L7.67578 11.252L5.11719 8.91602L8.55664 8.50586L9.98633 5.34961L11.4395 8.49414L14.8828 8.87891L12.3418 11.2344L13.0391 14.627L10.0156 12.9375L7.00391 14.6504Z",
    fill: "#F5732D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L5.11719 8.91602L7.67578 11.252L10 10Z",
    fill: "#FAA037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L7.00391 14.6504L10.0156 12.9375L13.0391 14.627L10 10Z",
    fill: "#FAA037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10L14.8828 8.87891L12.3418 11.2344L10 10Z",
    fill: "#FAA037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98633 5.34961L10 10L11.4395 8.49414L9.98633 5.34961Z",
    fill: "#FAA037"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_277_291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverBadge);
export default __webpack_public_path__ + "static/media/silver_badge.4cd30aee9ad0c92cf4d4a4198c6ec247.svg";
export { ForwardRef as ReactComponent };